var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBoldWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "8px",
    viewBox: "0 0 10 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "645AF81F-C872-4226-A18B-212174C07084") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherte-Bearbeiten-Popup",
    transform: "translate(-936.000000, -272.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(360.000000, 236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Person",
    transform: "translate(32.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ge\\xE4ndert",
    transform: "translate(537.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "15 10 10.875 14 9 12.1818182"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBoldWhite);
export default __webpack_public_path__ + "static/media/checkmark-bold-white.67c4d23e.svg";
export { ForwardRef as ReactComponent };